import React, { useState } from "react"

import { styled } from "@mui/material"

import { Avatar } from "./index"
import { IAvatar } from "./types/Avatar"

const Group = styled("div")({
  display: "flex"
})

const MAX_USERS = 6

interface IProps {
  items: IAvatar[],
  maxUsers?: number,
  disableActivate?: boolean
}

export const AvatarGroup = ({ items, maxUsers = MAX_USERS, disableActivate = true }: IProps) => {
  const [activated, setActive] = useState<string>()

  return <Group>
    {(items || [])
      .slice(0, maxUsers)
      .map(({ title, tooltip, picUrl, onClick, active }, index) =>

        <GroupItem
          key={`user_${title}_${index}`}
          onClick={() => {
            setActive(title)
            onClick?.()
          }}>

          <Avatar
            picUrl={picUrl}
            title={title}
            tooltip={tooltip}
            active={!disableActivate && activated === title || active}/>

        </GroupItem>
      )}

    {
      (items || []).length > maxUsers
      && <Counter>{`+${items.length - maxUsers}`}</Counter>
    }
  </Group>
}

const GroupItem = styled("div")({
  "&:not(:first-of-type)": {
    marginLeft: "-8px"
  }
})

const Counter = styled("div")({
  background: "#bdbdbd",
  borderRadius: "50%",
  color: "#fff",
  height: "24px",
  lineHeight: "24px",
  textAlign: "center",
  transform: "translateX(-8px)",
  width: "24px"
})
